import { render, staticRenderFns } from "./QuestionnaireDetail.vue?vue&type=template&id=6a2c4848&scoped=true&"
import script from "./QuestionnaireDetail.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireDetail.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireDetail.vue?vue&type=style&index=0&id=6a2c4848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c4848",
  null
  
)

component.options.__file = "QuestionnaireDetail.vue"
export default component.exports